import './App.css';
import { db } from './firebase';
import PageInvite from './PageInvite';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PageDiaporama from './PageDiaporama';
import PageInviteMultiple from './PageInviteMultiple';

//console.log("Firebase connecté :", db);

function App() {
    return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageInvite />} />
        <Route path="/diaporama" element={<PageDiaporama />} />
        <Route path="/ajouter-plusieurs" element={<PageInviteMultiple />} />
      </Routes>
    </BrowserRouter>
  );
}


export default App;
